import { minBrowsersSupport } from '../constantes/global.constants';

const hasRequiredFeatures = (): boolean => {
  return typeof ResizeObserver !== 'undefined'
    && typeof IntersectionObserver !== 'undefined'
    && typeof Intl !== 'undefined'
    && typeof Intl.RelativeTimeFormat === 'function'
    && typeof CSS !== 'undefined'
    && typeof CSS.supports === 'function'
    && CSS.supports('display', 'grid');
};

export const isSupportedBrowser = (): boolean => {
  if (!hasRequiredFeatures()) {
    return false;
  }

  const userAgent = navigator.userAgent;
  let browserName = '';
  let browserVersion = 0;

  if (/Chrome|chromium|crios/i.test(userAgent) && /Google Inc|Apple Computer/i.test(navigator.vendor)) {
    const versionMatch = userAgent.match(/(?:Chrome|chromium|crios)\/(\d+)/i);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Chrome';
    }
  }

  if (/Firefox/.test(userAgent)) {
    const versionMatch = userAgent.match(/Firefox\/(\d+)/);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Firefox';
    }
  }

  if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
    const versionMatch = userAgent.match(/Version\/(\d+)/);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Safari';
    }
  }

  if (/Opera/.test(userAgent) || /OPR/.test(userAgent)) {
    const versionMatch = userAgent.match(/(?:Opera|OPR)\/(\d+)/);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Opera';
    }
  }

  if (/Edg/.test(userAgent)) {
    const versionMatch = userAgent.match(/Edg\/(\d+)/);
    if (versionMatch) {
      browserVersion = parseInt(versionMatch[1], 10);
      browserName = 'Edge';
    }
  }

  switch (browserName) {
    case 'Chrome':
      return browserVersion >= minBrowsersSupport.chrome;
    case 'Firefox':
      return browserVersion >= minBrowsersSupport.firefox;
    case 'Safari':
      return browserVersion >= minBrowsersSupport.safari;
    case 'Opera':
      return browserVersion >= minBrowsersSupport.opera;
    case 'Edge':
      return browserVersion >= minBrowsersSupport.edge;
    default:
      return true;
  }
};
